import { privateAxios } from 'services/api/privateAxios';

export const completeOrder = id =>
  privateAxios({
    method: 'post',
    url: `/orderboard/complete/${id}`,
  });
